import { render, staticRenderFns } from "./NewsManage.vue?vue&type=template&id=488f5046"
import script from "./NewsManage.vue?vue&type=script&lang=js"
export * from "./NewsManage.vue?vue&type=script&lang=js"
import style0 from "./NewsManage.vue?vue&type=style&index=0&id=488f5046&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports